import { handleRadioChange } from './handleRadioChange';

import { handleCheckboxChange } from './handleCheckboxChange';
import {
  TPreciseFiltersState,
  EPreciseFilterTypes,
  IGetPreciseFiltersNextStateParams,
} from '../../../types/redux/preciseFilters';

export const getPreciseFiltersNextState = (params: IGetPreciseFiltersNextStateParams): TPreciseFiltersState => {
  const { filterValue, prevState, filterType, filterName } = params;

  let handler;

  switch (filterType) {
    case EPreciseFilterTypes.RadioButton:
      handler = handleRadioChange;
      break;
    default:
      handler = handleCheckboxChange;
  }

  return handler(filterValue, prevState, filterName);
};
